// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  @media (min-width: 769px) {
    display: none;
  }

  display: flex;
  align-items: center;
  margin-top: 16px;
`;

const StyledAction = styled.i`
  &&& {
    display: block;
    font-size: 23px;
    padding: 10px;
    cursor: pointer;
    background-color: ${props => (props.selected ? '#D37DA2' : '')};
  }
`;

const MobileTopPanelActions = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isFilterSelected,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isSortSelected,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onFilterClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onSortClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  noFilter,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  noSorter,
}) => (
  <StyledWrapper>
    {!noFilter && (
      <StyledAction
        className='fa fa-filter mobile-filter'
        selected={isFilterSelected}
        onClick={onFilterClick}
      />
    )}
    {!noSorter && (
      <StyledAction
        className='fa fa-sort'
        selected={isSortSelected}
        onClick={onSortClick}
      />
    )}
  </StyledWrapper>
);

export default MobileTopPanelActions;
